'use strict';

require('../../company/users/CompanyUserStarService.js');

function CompanyGuestPublicationsListStarredCtrl($scope, $stateParams, $state, publications, priorities, translations) {
  var i;
  $scope.publications = publications;
  $scope.$state = $state;
  $scope.priorityId = $stateParams.priorityId || null;
  $scope.more = false;

  if($scope.publications.length === 21) {
    $scope.more = true;
    $scope.publications.pop();
  }


  $scope.priorities = priorities;
  $scope.priorities.unshift({
    id: null,
    name: translations['publication.all-status']
  });

   $scope.$on('$select.select', function(ev, priorityId) {
    $scope.priorityId = priorityId;
    if(!$scope.priorityId) {
      $scope.priorityId = null;
    }
    var filter = {
      priorityId: $scope.priorityId,
      page: null
    };
    $state.go('root.company-guest.publications.listDrafts', filter);
  });

  priorities.$promise.then(function() {
    for (i = 0; i < priorities.length; i++) {
      $scope.priorities[priorities[i].id] = priorities[i];
    }
  });

  $scope.page = parseInt($stateParams.page, 10) || 1;
  $scope.companyId = $stateParams.companyId;
}

CompanyGuestPublicationsListStarredCtrl.resolve = {
  publications: ['$stateParams', 'CurrentUserService', 'CompanyUserStarService', function($stateParams, CurrentUserService, CompanyUserStarService) {
    return CurrentUserService.get().then(function(user) {
      var companyId = $stateParams.companyId,
      filter = {};

      filter.companyId = companyId;
      filter.userId = user.id;
      // Fetch 21 for pagination, but the offset should be using 20
      filter.limit = 21;
      var page = parseInt($stateParams.page, 10) || 1;
      filter.offset = (page - 1) * 20;

      return CompanyUserStarService.query(filter).$promise;
    });
  }],
  priorities: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
    return CompanyService.queryPriorities({companyId: $stateParams.companyId});
  }],
  translations: ['$translate', function($translate) {
    return $translate(['publication.all-status', 'publication.list-starred']);
  }]
};
module.exports = CompanyGuestPublicationsListStarredCtrl;

angular.module('dokiv')
  .controller('CompanyGuestPublicationsListStarredCtrl', ['$scope', '$stateParams', '$state', 'publications', 'priorities', 'translations', CompanyGuestPublicationsListStarredCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/publications/CompanyGuestPublicationsListStarredCtrl.js
// module id = 302
// module chunks = 0